import Component from 'navigation/component/Component';
import Form from 'components/form/Form';
import { bindMethod } from 'helpers/bind';
import AddToWishlist from 'components/add-to-wishlist/AddToWishlist';
class RowProductCard extends Component {
    constructor(el, options) {
        super(el, options);
        this.parent = options.parent;
    }
    getModuleParams() {
        return {
            parent: this.parent
        };
    }
    getModulesMap() {
        return {
            form: ['.row-product-card__form', Form],
            addToWishlist: ['.add-to-wishlist', AddToWishlist]
        };
    }
    bindEvents(add = true) {
        const method = bindMethod(add);
        if (this.refs.selects) {
            this.refs.selects.forEach(select => {
                select[method]('click', this.onSelectClick);
                select[method]('change', this.onSelectChange);
            });
        }
        if (this.refs.quantityLess)
            this.refs.quantityLess[method]('click', this.onQuantityUpdate);
        if (this.refs.quantityMore)
            this.refs.quantityMore[method]('click', this.onQuantityUpdate);
        if (this.refs.remove)
            this.refs.remove[method]('click', this.onQuantityUpdate);
    }
    onQuantityUpdate = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        const quantity = this.refs.quantity.value;
        if (parseInt(quantity) > 0) {
            const newQuantity = +quantity + parseInt(event.currentTarget.dataset.delta);
            this.refs.quantity.value = newQuantity.toString();
        }
        this.modules.form.submit();
    };
    onSelectChange = () => {
        this.modules.form.submit();
    };
    onSelectClick = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
    };
}
export default RowProductCard;
